// Lazily registers every Stimulus controller in this directory
// (files named *_controller.ts) with the application.
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.ts', { eager: true })
registerControllers(application, controllers)

application.debug = false

export { application }
